import React from "react";
import PropTypes from "prop-types";

import { Anchor, Button, Icon, Type } from "@ebscois/react-component-library";
import {
  BackgroundAndBorderWrapper,
  ConsentMessagingWrapper,
  ConsentControls,
  DismissConsent
} from "./CookieConsent.styled";

const CookieConsent = ({ acceptCookiesConsent, dismissCookiesConsent }) => {
  return (
    <BackgroundAndBorderWrapper>
      <ConsentMessagingWrapper
        container
        align={{ item: "center" }}
        justify={{ content: "space-between" }}
      >
        <Type>
          We use cookies to give you a better experience on our sites. To learn
          more about how we use cookies, please read our{" "}
          <Anchor href="https://more.ebsco.com/privacy-policy">
            privacy policy
          </Anchor>
          .
        </Type>
        <ConsentControls cell justify={{ content: "space-between" }}>
          <Button
            onClick={acceptCookiesConsent}
            kind="outlined"
            variant="primary"
          >
            Accept Cookies
          </Button>
          <DismissConsent
            onClick={dismissCookiesConsent}
            kind="text"
            size="iconOnly"
            padded={false}
            data-testid="cookieConsent-close"
          >
            <Icon icon={{ size: "md", glyph: "close", color: "dark" }} />
          </DismissConsent>
        </ConsentControls>
      </ConsentMessagingWrapper>
    </BackgroundAndBorderWrapper>
  );
};

CookieConsent.propTypes = {
  acceptCookiesConsent: PropTypes.func.isRequired,
  dismissCookiesConsent: PropTypes.func.isRequired
};

CookieConsent.displayName = "CookieConsent";

export default CookieConsent;
